import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-time-expired-svg',
  template: `
  <div class="svg-container">
  <svg width="79px" height="79px" viewBox="0 0 79 79" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 52.3 (67297) - http://www.bohemiancoding.com/sketch -->
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="04_Icons/Hero/time_expired" transform="translate(-1.000000, -1.000000)">
            <g id="np_time_1015020_737373" transform="translate(1.000000, 1.000000)" fill="#737373">
                <path d="M39,0 C17.4942857,0 0,17.4942857 0,39 C0,60.5057143 17.4942857,78 39,78 C60.5057143,78 78,60.5057143 78,39 C78,17.4942857 60.5057143,0 39,0 Z M39,72 C20.8028571,72 6,57.1971429 6,39 C6,20.8028571 20.8028571,6 39,6 C57.1971429,6 72,20.8028571 72,39 C72,57.1971429 57.1971429,72 39,72 Z M42,12.288 L36,12.288 L36,40.2754286 L51.636,55.3054286 L55.7945143,50.9795143 L41.9996571,37.7238 L42,12.288 Z" id="Shape" fill-rule="nonzero"></path>
            </g>
            <g id="Group" transform="translate(54.000000, 54.000000)">
                <circle id="Oval" fill="#FFFFFF" fill-rule="nonzero" cx="13" cy="13" r="13"></circle>
                <path d="M13.4333333,23.4 C7.45024854,23.4 2.6,18.5497515 2.6,12.5666667 C2.6,6.58358188 7.45024854,1.73333333 13.4333333,1.73333333 C19.4164181,1.73333333 24.2666667,6.58358188 24.2666667,12.5666667 C24.2666667,18.5497515 19.4164181,23.4 13.4333333,23.4 Z M13.4333333,20.6916667 C17.9206469,20.6916667 21.5583333,17.0539803 21.5583333,12.5666667 C21.5583333,8.07935307 17.9206469,4.44166667 13.4333333,4.44166667 C8.94601974,4.44166667 5.30833333,8.07935307 5.30833333,12.5666667 C5.30833333,17.0539803 8.94601974,20.6916667 13.4333333,20.6916667 Z" id="Combined-Shape" fill="#BF4B49" fill-rule="nonzero"></path>
                <text id="!" font-family="NotoSans-Bold, Noto Sans" font-size="15" font-weight="bold" fill="#BF4B49">
                    <tspan x="10.4" y="17.6">!</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>
</div>`
})
export class TimeExpiredSvgComponent {

}
